// Scroll reveals, the transparent-header state, the FAQ accordion, the back to
// top button and the testimonial carousel arrows.
//
// The document is marked only after the script runs, so if the file fails to
// load the content stays visible instead of sitting at opacity 0 forever.

(function () {
  var settings = (window.theme && window.theme.vrHome) || {};
  var stagger = settings.stagger || 0;

  function reveal(el) {
    var delay = parseInt(el.getAttribute('data-vr-delay'), 10);
    if (isNaN(delay)) delay = 0;
    setTimeout(function () {
      el.classList.add('is-revealed');
    }, delay);
  }

  var motionObserver = null;

  function startMotion() {
    var items = document.querySelectorAll('[data-vr-motion]:not([data-vr-watched])');
    if (!items.length) return;

    document.documentElement.classList.add('vr-motion-ready');

    // Stagger anything that sits in the same row of a grid.
    var groups = {};
    Array.prototype.forEach.call(items, function (el) {
      var group = el.getAttribute('data-vr-group');
      if (!group) return;
      groups[group] = groups[group] || 0;
      if (!el.hasAttribute('data-vr-delay')) {
        el.setAttribute('data-vr-delay', groups[group] * stagger);
      }
      groups[group]++;
    });

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, reveal);
      return;
    }

    if (!motionObserver) {
      motionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          motionObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    }

    Array.prototype.forEach.call(items, function (el) {
      // Marked, so a second pass over a page that has grown does not observe the
      // same element twice.
      el.setAttribute('data-vr-watched', '');
      motionObserver.observe(el);
    });
  }

  // Related products are fetched and written in after the page has loaded. They
  // arrive holding data-vr-motion, which means they start at nothing and wait to
  // be revealed by an observer that was set up before they existed. The result
  // was a row of product cards with the photographs downloaded and every one of
  // them invisible.
  function watchForLateMotion() {
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (settings.motion !== false) startMotion();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Header sits transparent over the top of the hero and turns solid as soon as
  // the page moves, rather than staying see-through for the whole hero. The
  // threshold is a short scroll distance, which is what the reference does.
  function watchHeader() {
    // the stylesheet keys off .header-wrapper, so the class has to land there
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var flip = parseInt(settings.headerFlip, 10);
    if (isNaN(flip)) flip = 60;

    function update() {
      header.classList.toggle('is-past-hero', window.pageYOffset > flip);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  // Back to top: hidden until the page has been scrolled past a threshold.
  function backToTop() {
    var btn = document.querySelector('.vr-to-top');
    if (!btn) return;

    var after = parseInt(btn.getAttribute('data-after'), 10);
    if (isNaN(after)) after = 600;

    var shown = false;
    function update() {
      var past = window.pageYOffset > after;
      if (past === shown) return;
      shown = past;
      if (past) {
        btn.hidden = false;
        // let the browser paint the hidden state before transitioning in
        requestAnimationFrame(function () {
          btn.classList.add('is-visible');
        });
      } else {
        btn.classList.remove('is-visible');
        setTimeout(function () {
          if (!shown) btn.hidden = true;
        }, 300);
      }
    }

    btn.addEventListener('click', function () {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
    });

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  // FAQ rows. Delegated from the document so a section redrawn in the editor
  // keeps working without being wired up again.
  function faq() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('.vr-faq__trigger');
      if (!trigger) return;

      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  }

  // Hero dots. Only present when the section has more than one slide; the track
  // is a plain scroll container, so the dots scroll it and read their state back
  // off the scroll position rather than tracking an index of their own.
  function heroDots() {
    document.querySelectorAll('[data-vr-hero-dots]').forEach(function (dots) {
      var hero = dots.closest('.vr-hero');
      var track = hero && hero.querySelector('.vr-hero__track--multi');
      if (!track) return;

      var buttons = Array.prototype.slice.call(dots.querySelectorAll('.vr-hero__dot'));

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = parseInt(btn.getAttribute('data-index'), 10) || 0;
          track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        });
      });

      function sync() {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach(function (btn, i) {
          btn.classList.toggle('is-active', i === index);
        });
      }

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  // Footer columns collapse on a phone. Delegated from the document so a footer
  // redrawn in the editor keeps working, and the closed state is the CSS default
  // so nothing has to run before first paint.
  function footerAccordions() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest && event.target.closest('.vr-footer__toggle');
      if (!toggle) return;

      // above the breakpoint the columns are always open and the button is inert
      if (window.matchMedia('(min-width: 769px)').matches) return;

      var block = toggle.closest('.footer-block');
      if (!block) return;

      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      block.classList.toggle('is-open', !open);
    });
  }

  // Dots for any row that scrolls a card at a time. The row is named by
  // aria-controls, so the same markup works wherever it is dropped, and the
  // active dot comes off the scroll position rather than a stored index.
  function stripDots() {
    document.querySelectorAll('[data-vr-dots]').forEach(function (dots) {
      var strip = document.getElementById(dots.getAttribute('aria-controls'));
      if (!strip) return;

      var buttons = Array.prototype.slice.call(dots.querySelectorAll('.vr-imagecards__dot'));

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var index = parseInt(btn.getAttribute('data-index'), 10) || 0;
          strip.scrollTo({ left: strip.clientWidth * index, behavior: 'smooth' });
        });
      });

      function sync() {
        var index = Math.round(strip.scrollLeft / strip.clientWidth);
        buttons.forEach(function (btn, i) {
          btn.classList.toggle('is-active', i === index);
        });
      }

      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  // The trust pills light up under the pointer. CSS :hover does this too, and on
  // its own it is usually enough, but the browser only recomputes :hover when
  // the pointer moves: scroll a pill up under a cursor that is sitting still and
  // it stays plain until the mouse twitches or something is clicked. This keeps
  // its own note of where the pointer is and asks the page again after a scroll.
  function pillHover() {
    var pills = document.querySelectorAll('.vr-features__block');
    if (!pills.length) return;

    var at = null;
    var queued = false;

    function apply() {
      queued = false;
      var under = at ? document.elementFromPoint(at.x, at.y) : null;
      pills.forEach(function (pill) {
        pill.classList.toggle('is-hovered', !!under && pill.contains(under));
      });
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    }

    document.addEventListener(
      'pointermove',
      function (event) {
        // A finger is not a pointer that hovers. Leaving the class off means a
        // tap does not stick the pill on until the next tap somewhere else.
        at = event.pointerType === 'touch' ? null : { x: event.clientX, y: event.clientY };
        schedule();
      },
      { passive: true }
    );

    document.addEventListener('pointerleave', function () {
      at = null;
      schedule();
    });

    window.addEventListener('scroll', schedule, { passive: true });
  }

  // A marquee with a speed in px/s gets its loop time from the width of one
  // set of images, so the pace is the same on a phone with small tiles and a
  // laptop with large ones, and does not change when an image is added. The
  // same measurement is taken again on resize and once the images have loaded,
  // since a tile without its picture is not yet the width it will be.
  function marqueeSpeed() {
    document.querySelectorAll('[data-vr-marquee-speed]').forEach(function (m) {
      var track = m.querySelector('.vr-marquee__track');
      var set = m.querySelector('.vr-marquee__set');
      var speed = parseFloat(m.dataset.vrMarqueeSpeed);
      if (!track || !set || !(speed > 0)) return;
      var apply = function () {
        var w = set.getBoundingClientRect().width;
        if (w > 0) track.style.animationDuration = (w / speed).toFixed(2) + 's';
      };
      apply();
      if (!m.dataset.vrMarqueeBound) {
        m.dataset.vrMarqueeBound = '1';
        window.addEventListener('resize', apply);
        m.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', apply, { once: true });
        });
      }
    });
  }

  // The boxed close inside the full-screen menu. Dawn opens and shuts the
  // drawer from its <summary>, so the box simply presses that: the body scroll
  // lock, the focus return and the animation all stay Dawn's.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-vr-mm-close]');
    if (!btn) return;
    var details = btn.closest('details');
    var summary = details && details.querySelector(':scope > summary');
    if (summary) summary.click();
  });

  function init() {
    if (settings.motion !== false) startMotion();
    watchForLateMotion();
    watchHeader();
    backToTop();
    faq();
    heroDots();
    stripDots();
    pillHover();
    footerAccordions();
    marqueeSpeed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is redrawn in the theme editor, otherwise anything
  // the merchant edits stays invisible until they reload.
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-vr-motion]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    watchHeader();
    marqueeSpeed();
  });
})();

/*
  Carousel controls, shared by any row that wants arrows.

  The row is a plain scroll container, so the arrows move it by one card and the
  browser keeps the smooth scrolling, the momentum and the snapping. Nothing here
  tracks an index, which means a drag or a keyboard scroll never falls out of
  step with the buttons.
*/
(function () {
  // Waits for the smooth scroll to come to rest. Watching the position rather
  // than listening for scrollend: setting the scroll by hand fires one of those
  // and the tidying would run before anything had moved.
  function settle(row, done) {
    var last = null;
    var quiet = 0;
    var started = Date.now();

    (function watch() {
      var at = Math.round(row.scrollLeft);
      quiet = at === last ? quiet + 1 : 0;
      last = at;
      if (quiet > 2 || Date.now() - started > 1500) {
        done();
        return;
      }
      requestAnimationFrame(watch);
    })();
  }

  // A second run of the same cards, printed after the first, so there is always
  // something past the end to scroll onto. The copies are hidden from screen
  // readers and taken out of the tab order: they are the same products.
  function buildLoop(row) {
    if (row.dataset.vrLooped === 'true') {
      return function () {
        return distanceOfRun(row);
      };
    }

    var originals = Array.prototype.slice.call(row.children);
    if (originals.length < 2) return null;

    originals.forEach(function (item) {
      var copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.classList.add('vr-carousel__copy');
      Array.prototype.forEach.call(copy.querySelectorAll('a, button, input, select'), function (el) {
        el.setAttribute('tabindex', '-1');
      });
      row.appendChild(copy);
    });

    row.dataset.vrLooped = 'true';
    row.dataset.vrLoopCount = String(originals.length);

    return function () {
      return distanceOfRun(row);
    };
  }

  // How far one run of cards reaches, measured from the first card to the first
  // of the copies. Read fresh each time, because the card width changes with the
  // window.
  function distanceOfRun(row) {
    var count = parseInt(row.dataset.vrLoopCount, 10);
    var items = row.children;
    if (!count || items.length <= count) return 0;
    return items[count].offsetLeft - items[0].offsetLeft;
  }

  function step(row) {
    var card = row.querySelector('[data-vr-carousel-item]');
    if (!card) return row.clientWidth;
    var style = getComputedStyle(row);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function setup(controls) {
    // Idempotent: the recommendations row arrives after the page has loaded and
    // setup runs again for it, but the rows that were already here must not
    // collect a second set of listeners.
    if (controls.dataset.vrCarouselReady) return;
    var anchor = controls.querySelector('[aria-controls]');
    if (!anchor) return;
    controls.dataset.vrCarouselReady = 'true';
    var row = document.getElementById(anchor.getAttribute('aria-controls'));
    if (!row) return;

    var prev = controls.querySelector('[data-vr-carousel-prev]');
    var next = controls.querySelector('[data-vr-carousel-next]');
    var loop = row.dataset.vrLoop === 'true' && buildLoop(row);

    function sync() {
      // Nothing ever runs out on a row that comes round, so neither arrow is
      // ever the one with nowhere to go.
      if (loop) {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        return;
      }
      // A fractional scroll width is common once the cards carry sub-pixel
      // widths, so the end needs a pixel of slack or the arrow never enables.
      var max = row.scrollWidth - row.clientWidth;
      if (prev) prev.disabled = row.scrollLeft <= 1;
      if (next) next.disabled = row.scrollLeft >= max - 1;
    }

    function jump(to) {
      row.style.scrollBehavior = 'auto';
      row.scrollLeft = to;
      row.style.scrollBehavior = '';
    }

    // The row holds two identical runs of the same cards. Once the scroll has
    // gone a whole run past the start it is put back by exactly that distance,
    // which lands on the matching card in the first run: the same picture in the
    // same place, so the move cannot be seen and there is no end to reach.
    function normalise() {
      if (!loop) return;
      var run = loop();
      if (run <= 0) return;
      if (row.scrollLeft >= run) jump(row.scrollLeft - run);
    }

    function move(direction) {
      if (loop && direction < 0 && row.scrollLeft < step(row) / 2) {
        // At the very start there is nothing to the left yet. Shift forward a
        // whole run first, without animating, so the step back has somewhere to
        // go and the row appears not to have moved.
        jump(row.scrollLeft + loop());
      }
      row.scrollBy({ left: step(row) * direction, behavior: 'smooth' });
      if (loop) settle(row, normalise);
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    // A drag or a trackpad flick has to come round too, so the position is put
    // back once the scrolling has stopped rather than only after an arrow.
    var quiet;
    row.addEventListener(
      'scroll',
      function () {
        sync();
        if (!loop) return;
        clearTimeout(quiet);
        quiet = setTimeout(normalise, 180);
      },
      { passive: true }
    );
    window.addEventListener('resize', sync);
    sync();
  }

  function setupAll() {
    document.querySelectorAll('[data-vr-carousel-controls]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', setupAll);

  // Related products are fetched and written in after the page has loaded, so
  // their arrows were never wired up: they sat there enabled and did nothing.
  // Watching the document catches those and anything else drawn in later.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes.length) {
        setupAll();
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // The cart drawer's countdown. It counts and nothing else: no stock is held,
  // so it stops at zero rather than pretending to release anything.
  function cartClock() {
    document.querySelectorAll('[data-vr-cart-timer]').forEach(function (bar) {
      if (bar.dataset.vrClockReady) return;
      bar.dataset.vrClockReady = 'true';

      var face = bar.querySelector('[data-vr-cart-clock]');
      if (!face) return;

      var left = (parseInt(bar.dataset.minutes, 10) || 10) * 60;

      function paint() {
        var m = Math.floor(left / 60);
        var s = left % 60;
        face.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      }

      paint();
      var tick = setInterval(function () {
        left -= 1;
        if (left <= 0) {
          left = 0;
          clearInterval(tick);
        }
        paint();
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cartClock);
  } else {
    cartClock();
  }

  // The drawer is replaced wholesale when the cart changes, so the clock has to
  // be found again rather than only at first paint.
  new MutationObserver(cartClock).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

})();
